import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import MessagingSearchDetailedChat from "./routes";
export default store => ({
  path: "messaging/search",
  exact: true,
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "messaging-search" */ "./components"),
        import(
          /* webpackChunkName: "messaging-search" */ "MessagingV2/modules/MessagingModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const module = importedModule1;
        injectReducer(store, {
          key: module.NAME,
          reducer: module.default,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [MessagingSearchDetailedChat(store)],
});
